import { RollingTextList, ListItem } from "@/components/ui/rolling-list";
import italyCoast from "@/assets/images/italy-coast.webp";
import roadtripVan from "@/assets/images/roadtrip-van.webp";
import friendsMountain from "@/assets/images/friends-mountain.webp";
import airplaneSunset from "@/assets/images/airplane-sunset.jpg";
import lakeBoat from "@/assets/images/lake-boat.webp";

const topics: ListItem[] = [
  { id: 1, title: "Rejse & Udland", category: "Backpacking", src: italyCoast, alt: "Rejse i udlandet", href: "/kategori/rejse-udland" },
  { id: 2, title: "Højskole", category: "Uddannelse", src: roadtripVan, alt: "Højskoleophold", href: "/kategori/hoejskole-uddannelse" },
  { id: 3, title: "Frivilligt arbejde", category: "Erfaring", src: friendsMountain, alt: "Frivilligt arbejde", href: "/kategori/arbejde-frivillighed" },
  { id: 4, title: "Økonomi & SU", category: "Planlægning", src: airplaneSunset, alt: "Økonomisk planlægning", href: "/kategori/oekonomi-planlaegning" },
  { id: 5, title: "Working Holiday", category: "Arbejde", src: lakeBoat, alt: "Working holiday", href: "/kategori/arbejde-frivillighed" },
];

export default function SabbatTopicsList() {
  return (
    <section className="py-12 md:py-16 bg-muted/30">
      <div className="container">
        <RollingTextList
          items={topics}
          title="Udforsk emner"
          subtitle="Find det der passer til dit sabbatår"
        />
      </div>
    </section>
  );
}
